<script setup lang="ts">
import { ref } from 'vue'
import { Head, Link } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue';
import { useFormatTime } from '@/Composables/useFormatTime'
import { useFormatCurrency } from '@/Composables/useFormatCurrency'
import CreateInvoice from '@/Components/Master/Invoices/CreateInvoice.vue';
import PrintInvoicesPDF from '@/Components/Master/Invoices/PrintInvoicesPDF.vue';
import Tag from '@/Components/Utils/Tag.vue';


const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    data: {}
    type_invoices?: {
        label: string
        value: string
    }[]
}>()

const selectedInvoices = ref<any[]>([])

const handleSelectRow = (selectRow: { [key: string]: boolean }) => {
    const allData = (props.data as any)?.data ?? []
    selectedInvoices.value = allData.filter((inv: any) => selectRow[inv.id] === true)
}

const generateLinkInvoice = (invoice: {slug: string}) => {
    switch (route().current()) {
        case 'sales.invoices.index':
            return route('sales.invoices.show', invoice.slug)
        case 'casheer.invoices.index':
            return route('casheer.invoices.show', invoice.slug)

        default:
            return '#'
    }
}

</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead">
        <template #other>
            <PrintInvoicesPDF :invoices="selectedInvoices" />
            <CreateInvoice v-if="type_invoices" :type_invoices />
        </template>
    </PageHeading>
    
    <Table
        :resource="data"
        name="default"
        :isCheckBox="true"
        checkboxKey="id"
        @onSelectRow="handleSelectRow"
    >
        <template #cell(reference)="{ item }">
            <div class="space-x-1">
                <Link :href="generateLinkInvoice(item)" class="primaryLink">
                    {{ item.reference }}
                </Link>
            </div>
        </template>
        
        <template #cell(created_at)="{ item }">
            {{ useFormatTime(item.created_at) }}
        </template>

        <template #cell(sales)="{ item }">
            {{ item.sales?.name || '-' }}
        </template>
        
        <template #cell(final_total_transfer)="{ item }">
            <span v-if="(item.final_total_transfer || 0)" class="font-semibold mr-2">{{ useFormatCurrency(item.final_total_transfer || 0) }}</span>
            <span v-else class="mr-2 text-gray-500">-</span>
            <Tag v-if="item.billing_date" label="Lunas" :theme="3" size="xxs" noHoverColor />
        </template>
        
        <template #cell(final_total_cash)="{ item }">
            <span v-if="(item.final_total_cash || 0)" class="font-semibold mr-2">{{ useFormatCurrency(item.final_total_cash || 0) }}</span>
            <span v-else class="mr-2 text-gray-500">-</span>
            <Tag v-if="item.invoice_cash?.billing_date" label="Lunas" :theme="3" size="xxs" noHoverColor />
        </template>
    </Table>

    
</template>